(function () {
  function bindForm(form) {
    if (!form || form.hasAttribute('data-wellness-guide-bound')) return;

    var endpoint = form.getAttribute('data-wellness-guide-endpoint');
    if (!endpoint) return;

    form.setAttribute('data-wellness-guide-bound', 'true');

    var email = form.querySelector('[data-wellness-guide-email]');
    var submit = form.querySelector('[data-wellness-guide-submit]');
    var success = form.querySelector('[data-wellness-guide-success]');
    var error = form.querySelector('[data-wellness-guide-error]');

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      if (!email || !email.checkValidity()) {
        if (email) email.reportValidity();
        return;
      }

      setMessage(success, '', true);
      setMessage(error, '', true);
      setLoading(form, submit, true);

      fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          email: email.value,
          source: form.getAttribute('data-wellness-guide-source') || 'wellness-assessment-guide',
          page: window.location.href,
          hp: getHoneypotValue(form),
        }),
      })
        .then(function (response) {
          return response.json().catch(function () {
            return {};
          }).then(function (body) {
            if (!response.ok || !body.ok) {
              throw new Error(body.error || 'Please check your email address and try again.');
            }

            return body;
          });
        })
        .then(function () {
          form.reset();
          setMessage(success, success.getAttribute('data-success-message'), false);
          success.focus({ preventScroll: true });
        })
        .catch(function (submissionError) {
          setMessage(error, submissionError.message, false);
          error.focus({ preventScroll: true });
        })
        .finally(function () {
          setLoading(form, submit, false);
        });
    });
  }

  function getHoneypotValue(form) {
    var honeypot = form.querySelector('[name="hp"]');
    return honeypot ? honeypot.value : '';
  }

  function setLoading(form, submit, isLoading) {
    form.classList.toggle('is-loading', isLoading);

    if (submit) {
      submit.disabled = isLoading;
      submit.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    }
  }

  function setMessage(element, message, hidden) {
    if (!element) return;

    element.textContent = message || '';
    element.hidden = hidden;
  }

  function init() {
    document.querySelectorAll('[data-wellness-guide-form]').forEach(bindForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
